export default "__VITE_ASSET__CBNoOWPJ__"